import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { compose } from 'recompose'
// import { authenticateByCredentials } from 'actions/Auth'
import LearnSiplahView from 'components/publicPages/learnSiplah'

const mapStateToProps = () => ({})

const mapDispatchToProps = () => ({
  // loginWithCredentials: bindActionCreators(authenticateByCredentials, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),

)(LearnSiplahView)
